/** Http interceptor providers in outside-in order */
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {BasicHttpInterceptor} from './BasicHttpInterceptor';

export const httpInterceptorProviders = [{provide: HTTP_INTERCEPTORS, useClass: BasicHttpInterceptor, multi: true}];
